import moment from 'moment-timezone'
import Convertdec from 'decimal-number-to-words'
import parseHtml from 'html-react-parser'
import sanitize from 'sanitize-html'
import { parseDateTime } from '../../../utils/date-time'

const momentDateFormats = {
  PKDateStyleNone: "",
  PKDateStyleShort: "DD/MM/YY",
  PKDateStyleMedium: "DD MMM YYYY",
  PKDateStyleLong: "DD MMMM YYYY",
  PKDateStyleFull: "dddd DD MMMM YYYY"
}

const momentTimeFormats = {
  PKDateStyleNone: "",
  PKDateStyleShort: "HH:mm",
  PKDateStyleMedium: "HH:mm:SS",
  PKDateStyleLong: "HH:mm:SS",
  PKDateStyleFull: "HH:mm:SS"
}

const momentTimeFormatSuffixes = {
  PKDateStyleNone: "",
  PKDateStyleShort: "",
  PKDateStyleMedium: "",
  PKDateStyleLong: " GMT",
  PKDateStyleFull: " Greenwich Mean Time"
}

const cleanHtml = text =>
  sanitize(text?.toString() ?? "", {
    allowedTags: ["br"],
    selfClosing: ["br"],
    disallowedTagsMode: 'discard',
  })

const newLinesToBrTags = text => text?.replace(/\n/g, "<br/>")

const tabsToNbsp = text => text?.replace(/\t/g, "&nbsp;&nbsp;&nbsp;")

const applyAppleFormat = ({ item, resolvedValue }) => {
  if (["date", "time", "datetime"].includes(item.type)) {

    const date = parseDateTime(resolvedValue, item.ignoresTimeZone)

    if (date.isValid()) {

      let format = ""

      const dateStyle = item.dateStyle
      const timeStyle = item.timeStyle

      if (dateStyle) format += momentDateFormats[dateStyle]
      if (dateStyle && timeStyle) format += " "
      if (timeStyle) format += momentTimeFormats[timeStyle]

      const formattedDateTime = date.format(format)

      return formattedDateTime + (timeStyle ? momentTimeFormatSuffixes[timeStyle] : "")

    } else return "Invalid date. Use ISO format, e.g. 2026-03-14T13:33:55+00:00"
  }

  if (item.type === "money") {
    const numericValue = parseFloat(resolvedValue)
    return numericValue.toLocaleString('en-US', { style: 'currency', currency: item.currencyCode })
  }

  if (item.type === "number") {
    const numericValue = parseFloat(resolvedValue)

    switch (item.numberStyle) {
      case "PKNumberStyleDecimal": return numericValue
      case "PKNumberStylePercent": return numericValue * 100 + "%"
      case "PKNumberStyleScientific": return numericValue.toExponential().replace("e+0", "E0")
      case "PKNumberStyleSpellOut": return Convertdec.toWords(numericValue)
    }
  }

  return resolvedValue
}

const addDataFormatting = ({item, resolvedValue}) => {
  const step0 = applyAppleFormat({item, resolvedValue})
  const step1 = cleanHtml(step0)
  const step2 =  newLinesToBrTags(step1)
  const step3 =  tabsToNbsp(step2)
  return parseHtml(step3)
}

export default addDataFormatting
